import { Component } from '@angular/core';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrl: './about.component.scss'
})
export class AboutComponent {
    expertise = [
        'Automotive & Auto Components',
        'Engineering & Fabrication Units',
        'CNC & Precision Tool Rooms',
        'Small & Medium Manufacturing Industries',
        'Industrial Production Units'
    ];

    services = [
        { icon: 'fas fa-shopping-cart', title: 'Tool Room Machinery Sales' },
        { icon: 'fas fa-wrench', title: 'Machine Installation & Commissioning' },
        { icon: 'fas fa-shield-alt', title: 'Preventive Maintenance Services' },
        { icon: 'fas fa-ambulance', title: 'Breakdown & On-site Service Support' },
        { icon: 'fas fa-boxes', title: 'Spare Parts Supply & Replacement' },
        { icon: 'fas fa-sync-alt', title: 'Machine Reconditioning & Retrofitting' }
    ];
}
